import { render, staticRenderFns } from "./DialogAddContentBlock.vue?vue&type=template&id=be819758&scoped=true&"
import script from "./DialogAddContentBlock.vue?vue&type=script&lang=js&"
export * from "./DialogAddContentBlock.vue?vue&type=script&lang=js&"
import style0 from "./DialogAddContentBlock.vue?vue&type=style&index=0&id=be819758&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be819758",
  null
  
)

export default component.exports